<ng-container *ngIf="!isLoading; else loading">
  <form
    class="filter-row"
    [formGroup]="filtersForm"
    [style.--cells]="cells"
    [style.--items-per-row]="itemsPerRow"
    [style.--areas]="areas"
    [class.cells]="cells"
    [class.areas]="areas"
    [class.disabled]="filterProvider?.filterDisabled"
  >
    <ng-container *ngFor="let filterItem of filterItems.items">
      <textbox-filter-item
        *ngIf="filterItem.type === 'text'"
        [class]="filterItem.class"
        [style.grid-area]="filterItem.class"
        [filterItem]="filterItem"
        [formGroup]="filtersForm"
        [attr.disabled]="filterItem.disabled ? '' : null"
      >
      </textbox-filter-item>

      <div
        class="filter-item"
        *ngIf="filterItem.type === 'number'"
        [class]="filterItem.class"
        [style.grid-area]="filterItem.class"
      >
        <span class="input-label">{{ filterItem.caption }}</span>

        <input
          class="input"
          type="number"
          inputmode="descimal"
          [formControlName]="filterItem.name"
          [placeholder]="filterItem.placeholder"
        />
      </div>

      <dropdown-filter-item
        *ngIf="filterItem.type === 'select'"
        [class]="filterItem.class"
        [style.grid-area]="filterItem.class"
        [filterItem]="filterItem"
        [formGroup]="filtersForm"
      >
      </dropdown-filter-item>

      <showlast-filter-item
        *ngIf="isShowlastItem(filterItem) as filterShowLastItem"
        (change)="onShowLastChange($event)"
        [class.disabled]="isShowLastDisabled"
        [class]="filterShowLastItem.class"
        [formControlName]="filterShowLastItem.name"
        [style.grid-area]="filterShowLastItem.class"
        [filterItem]="filterShowLastItem"
      >
      </showlast-filter-item>

      <div
        *ngIf="isNgSelectItem(filterItem) as filterNgSelectItem"
        [class]="filterNgSelectItem.class"
        [style.grid-area]="filterNgSelectItem.class"
      >
        <span class="input-label">{{ filterNgSelectItem.caption }} </span>
        <div>
          <!-- class="fixed-height" -->
          <ng-select
            [items]="filterNgSelectItem.values"
            [multiple]="filterNgSelectItem.multiple"
            [bindLabel]="filterNgSelectItem.bindLabel"
            [bindValue]="filterNgSelectItem.bindValue"
            [closeOnSelect]="false"
            [placeholder]="filterNgSelectItem.placeholder ?? ''"
            [formControlName]="filterNgSelectItem.name"
            appendTo="body"
          >
            <ng-template
              *ngIf="filterNgSelectItem.withCheckbox"
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <label class="checkbox fw-bold">
                <input
                  id="item-{{ index }}"
                  type="checkbox"
                  [checked]="item$.selected"
                />
                <span class="text">
                  {{ item[filterNgSelectItem.bindLabel] }}
                </span>
              </label>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div
        class="d-flex"
        *ngIf="isDateRangeItem(filterItem) as filterDateRangeItem"
        [class.disabled]="isDateRangeDisabled"
        [class]="filterDateRangeItem.class"
        [class.flex-column]="filterDateRangeItem.isVertical"
        [style.grid-area]="filterDateRangeItem.class"
      >
        <div class="w-100">
          <span class="input-label"
            >{{
              filterDateRangeItem.captionFrom
                ? filterDateRangeItem.captionFrom
                : 'start date'
            }}
          </span>

          <datepicker
            [formControlName]="filterDateRangeItem.dateFromControlName"
            (ngModelChange)="
              onDateRangeChange(
                filterDateRangeItem.dateFromControlName,
                filterDateRangeItem.dateToControlName
              )
            "
            [hasTooltipValidation]="true"
            [maxDate]="dateFromMaxDate"
          ></datepicker>
        </div>

        <div
          class="w-100"
          [class.ml-3]="!filterDateRangeItem.isVertical"
          [class.mt-3]="filterDateRangeItem.isVertical"
        >
          <span class="input-label"
            >{{
              filterDateRangeItem.captionTo
                ? filterDateRangeItem.captionTo
                : 'end date'
            }}
          </span>

          <datepicker
            [formControlName]="filterDateRangeItem.dateToControlName"
            (ngModelChange)="
              onDateRangeChange(
                filterDateRangeItem.dateFromControlName,
                filterDateRangeItem.dateToControlName
              )
            "
            [hasTooltipValidation]="true"
            [minDate]="dateToMinDate"
            [addEndOfDayTime]="true"
          >
          </datepicker>
        </div>
      </div>

      <div
        *ngIf="isRadioItem(filterItem) as filterRadioItem"
        [class]="filterRadioItem.class"
        [style.grid-area]="filterRadioItem.class"
      >
        <span class="input-label">
          {{ filterRadioItem.caption }}
        </span>

        <div class="filter-elements-wrapper">
          <label
            class="input-wrap radio"
            *ngFor="let radio of filterRadioItem.values"
          >
            <input
              type="radio"
              [formControlName]="filterRadioItem.name"
              [name]="filterRadioItem.name"
              [value]="radio.value"
            />
            <span class="text">
              {{ radio.text }}
            </span>
          </label>
        </div>
      </div>

      <div
        *ngIf="isCheckboxItem(filterItem) as filterCheckboxItem"
        [class]="filterCheckboxItem.class"
        [style.grid-area]="filterCheckboxItem.class"
      >
        <span class="input-label">
          {{ filterCheckboxItem.caption }}
        </span>
        <div class="filter-elements-wrapper">
          <label
            class="checkbox fw-bold"
            *ngFor="let checkbox of filterCheckboxItem.values"
          >
            <input
              type="checkbox"
              [checked]="checkbox.checked"
              [value]="checkbox.value"
              (change)="onCheckChange($event, filterCheckboxItem.name)"
            />
            <span class="text">
              {{ checkbox.text }}
            </span>
          </label>
        </div>
      </div>

      <div *ngIf="filterItem.type === 'states'">
        <span class="input-label">
          {{ filterItem.caption }}
        </span>
        <states
          [formControlName]="filterItem.name"
          [class]="filterItem.class"
          [style.grid-area]="filterItem.class"
        >
        </states>
      </div>

      <div
        *ngIf="isHorizontalSwitchItem(filterItem) as filterSwitchItem"
        [class]="filterSwitchItem.class"
        [style.grid-area]="filterSwitchItem.class"
      >
        <div class="horizontalSwitch">
          <ng-container *ngFor="let radio of filterSwitchItem.values">
            <input
              type="radio"
              [formControlName]="filterSwitchItem.name"
              [name]="filterSwitchItem.name"
              [value]="radio.value"
              id="{{ radio.value }}"
            />
            <label for="{{ radio.value }}">{{ radio.text }}</label>
          </ng-container>
        </div>
      </div>

      <div
        class="d-flex"
        *ngIf="isDateRangeCalendarInlineItem(filterItem) as filterDateRangeItem"
        [class.disabled]="isDateRangeDisabled"
        [class]="filterDateRangeItem.class"
        [class.flex-column]="getVerticalItem(filterDateRangeItem)?.isVertical"
        [style.grid-area]="filterDateRangeItem.class"
      >
        <div class="w-100">
          <div class="date-range-calendar-inline-form-group">
            <label>{{
              getDateRangeCaption(filterDateRangeItem)?.captionFrom ||
                'start date'
            }}</label>
            <input
              type="date"
              [formControlName]="
                getDateRangeItem(filterDateRangeItem)?.dateFromControlName ?? ''
              "
              [name]="getDateRangeItem(filterDateRangeItem)?.name ?? ''"
              (ngModelChange)="
                onDateRangeChange(
                  getDateRangeItem(filterDateRangeItem)?.dateFromControlName ??
                    '',
                  getDateRangeItem(filterDateRangeItem)?.dateToControlName ?? ''
                )
              "
              [max]="dateFromMaxDate"
            />
          </div>
        </div>

        <div
          class="w-100"
          [class.ml-3]="!getVerticalItem(filterDateRangeItem)?.isVertical"
          [class.mt-3]="getVerticalItem(filterDateRangeItem)?.isVertical"
        >
          <div class="date-range-calendar-inline-form-group">
            <label>{{
              getDateRangeCaption(filterDateRangeItem)?.captionFrom ||
                'end date'
            }}</label>
            <input
              *ngIf="getDateRangeItem(filterDateRangeItem) as dateRangeItem"
              type="date"
              [formControlName]="dateRangeItem.dateToControlName"
              [name]="dateRangeItem.name"
              (ngModelChange)="
                onDateRangeChange(
                  dateRangeItem.dateFromControlName,
                  dateRangeItem.dateToControlName
                )
              "
              [min]="dateToMinDate"
            />
          </div>
        </div>
      </div>
    </ng-container>

    <div class="btn-group" [class.filter-button-group]="areas">
      <button type="submit" class="button blue w-100" (click)="onSubmit()">
        Apply Filter
      </button>

      <div class="btn-group" ngbDropdown>
        <button class="button blue" ngbDropdownToggle>
          <i class="fas fa-caret-down"></i>
        </button>

        <div class="padding-top" ngbDropdownMenu>
          <div class="dropdown-menu-inside">
            <button
              (click)="setDefaultQuickFilter()"
              class="dropdown-item"
              [disabled]="!defaultQuickFilter"
              ngbDropdownItem
            >
              Set Default
            </button>

            <button
              ngbDropdownItem
              class="dropdown-item"
              [disabled]="
                (filtersForm.touched && filtersForm.invalid) ||
                !someFilterValueIsSpecified
              "
              (click)="addQuickFilter()"
            >
              Add Quick Filter
            </button>

            <button
              ngbDropdownItem
              class="dropdown-item"
              [disabled]="!someFilterValueIsSpecified"
              (click)="resetFilters()"
            >
              Reset Filters
            </button>

            <ng-container *ngIf="quickFilters.length">
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header">Filters</h6>
            </ng-container>

            <div class="dropdown-filters">
              <div *ngFor="let quickFilter of quickFilters">
                <button
                  ngbDropdownItem
                  (click)="setQuickFilter(quickFilter.name)"
                  class="dropdown-item"
                >
                  {{ quickFilter.name }}
                  <span
                    class="badge badge-secondary ml-2"
                    *ngIf="quickFilter.default"
                  >
                    Default
                  </span>
                </button>
              </div>
            </div>

            <button
              (click)="openManageFiltersModal()"
              [disabled]="!quickFilters || quickFilters.length === 0"
              class="dropdown-item with-border"
              ngbDropdownItem
            >
              Manage Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>

<ng-template #loading>
  <loader style="height: 100px"></loader>
</ng-template>
